import { AchievementProgressItemStyled } from "./styled/AchievementProgressStyled";
import { PUBLIC_URL } from "../../../config";
import { AchievementPreviewProgressStyled } from "./styled/AchievementPreviewStyled";
import React, { useCallback, useMemo, useState } from "react";
import AchievementModal from "./AchievementModal";
import { ACHIEVEMENT_STATUS } from "../achievementsConstants";
import { useLangContext } from "../../../providers/LangProvider/LangProviderContext";
import { IUserAchievementSummary } from '../achievements.t';

interface IAchievementProgressItemProps {
    achievement: IUserAchievementSummary;
}

function AchievementProgressItem(props: IAchievementProgressItemProps) {
    const {
        achievement,
    } = props;
    const { getLangPath } = useLangContext();
    const [showModal, setShowModal] = useState(false);

    const onClickHandler = useCallback(() => {
        setShowModal(true);
    }, []);

    const handleClose = useCallback(() => {
        setShowModal(false);
    }, []);

    const progress = useMemo(() => {
        if (achievement.status === ACHIEVEMENT_STATUS.COMPLETED || achievement.target === 0 || !!achievement.times) return 0;
        return Math.max(3, (achievement.progress / achievement.target) * 100);
    }, [achievement]);

    return <>

        <AchievementModal
            achievement={achievement}
            showModal={showModal}
            progress={progress}
            handleClose={handleClose}/>

        <AchievementProgressItemStyled onClick={onClickHandler}>

            <div>
                <img src={`${PUBLIC_URL}/assets/achievements/${achievement.achievement_name}_inactive.png`}
                     alt={''}/>
            </div>
            <div className={'flex-1'} style={{ overflow: 'hidden' }}>
                <div style={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                }}>{getLangPath(`achievements.progress.categories.${achievement.category}`, {
                    amount: achievement.progress.toString(),
                    target: achievement.target.toString(),
                })}</div>
                <div className={'mt-2 mb-1'}>
                    <AchievementPreviewProgressStyled
                        className={'m-0'}
                        percent={Math.max(3, (achievement.progress / achievement.target) * 100)}/></div>
            </div>
        </AchievementProgressItemStyled>
    </>
}

export default AchievementProgressItem;
